import React, {useContext, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {AppContext} from '../../context';
import {useDataAccess} from '../custom_hooks';
import {parseError} from "../../utils/hydraParser";
import {ManageLinks} from "../common";

const Links = props => {
    const { t } = useTranslation();
    const {
        appState,
        fetchInitAppState,
        fetchSuccessAppState,
        fetchErrorAppState,
        addRefreshResourceAppState,
        forceRefreshResourceAppState,
        showMessageAppState,
        setPageInfos
    } = useContext(AppContext);
    const {fetch} = useDataAccess();
    const [catalog, setCatalog] = useState(null);

    useEffect(() => {
        setPageInfos('catalog_links', false);
        setCatalogFromCache();
        addRefreshResourceAppState(`catalogs/${props.match.params.id}`);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setCatalogFromCache();
        // eslint-disable-next-line
    }, [appState.cachedData.catalogs]);

    const setCatalogFromCache = () => {
        if(
            appState.cachedData &&
            appState.cachedData.catalogs &&
            appState.cachedData.catalogs[props.match.params.id]
        ) {
            setCatalog(appState.cachedData.catalogs[props.match.params.id]);
        } else {
            setCatalog(null);
        }
    };

    const submitLinks = grantedOrganizations => {
        fetchInitAppState();
        fetch(
            `catalogs/${props.match.params.id}`,
            {
                method: 'PUT',
                body: {
                    grantees: grantedOrganizations
                }
            }
        )
            .then(() => {
                fetchSuccessAppState();
                forceRefreshResourceAppState(`catalogs/${props.match.params.id}`);
                showMessageAppState('success', t('links_updated'));
            })
            .catch(error => {
                fetchErrorAppState(parseError(error));
            });
    };

    return (
        catalog &&
        catalog.grantees &&
        <ManageLinks type='catalog' element={catalog.grantees} submit={submitLinks} />
    )
};

export default Links;